












































import {Component, Prop, Vue} from "vue-property-decorator";

@Component({})
export default class ProductImageUpload extends Vue {
    @Prop({ required:true }) data!:any;
    @Prop({ required:true }) productImages!:any[];
    uploadedImages : any[] = [];

    uploadMultipleImage(e : any){
        this.uploadedImages = [];
        console.log("E",e);
        let key = 0;
        for (const file of e.target.files){
          this.data["image_show["+key+"]"] = file;
          let reader = new FileReader();
          reader.onloadend = ()=>{
            this.uploadedImages.push(reader.result);
          }
          reader.readAsDataURL(file);
          key ++;
        }
    }
    selectMainJpg(key : number){
        //console.log(key);
        this.data.product_images_id = key;
    }
    async deleteProductImage(item : any){
        let ask = confirm("Resim silinecek onaylıyormusunuz ?");
        if(ask){
            let response = await this.$http.delete("productImages/"+item.product_images_id);
            if(response.status == 200){
                this.productImages.splice(this.productImages.indexOf(item),1);
            }
        }
    }
}
